<template>
  <div class="customerBusinessStatisticsDetail">
    <van-form label-width="120px">
      <div class="title">{{ $t.meta.basicTitle }}</div>
      <van-field
        v-model="form.CustomerNumber"
        :label="$t.customerBusinessStatistics.customerNumber"
        readonly
      />
      <van-field
        v-model="form.CompanyName"
        :label="$t.customerBusinessStatistics.companyName"
        type="textarea"
        rows="3"
        readonly
      />
      <van-field
        v-model="form.TotalVotes"
        :label="$t.customerBusinessStatistics.totalVotes"
        readonly
      />

      <van-field
        v-model="form.AirTotalVotes"
        :label="$t.customerBusinessStatistics.airTotalVotes"
        readonly
      />

      <van-field
        v-model="form.SeaTotalVotes"
        :label="$t.customerBusinessStatistics.seaTotalVotes"
        readonly
      />

      <van-field
        v-model="form.ExpressTotalVotes"
        :label="$t.customerBusinessStatistics.expressTotalVotes"
        readonly
      />

      <van-field
        v-model="form.WarehouseTotalVotes"
        :label="$t.customerBusinessStatistics.warehouseTotalVotes"
        readonly
      />

      <div class="title">{{ $t.customerBusinessStatistics.amountTitle }}</div>

      <div class="subTotal" v-if="listAmount && listAmount.length > 0">
        <div class="subTotal-label" v-if="menuState == 1">
          {{ $t.customerBusinessStatistics.payAmount }}
        </div>
        <div class="subTotal-label" v-if="menuState == 2">
          {{ $t.customerBusinessStatistics.receivedAmount }}
        </div>
        <div class="subTotal-item" v-for="(item, index) in listAmount" :key="index">
          <div class="item1">{{ item.key }}</div>
          <div class="item2">{{ item.value }}</div>
        </div>
      </div>

      <div class="subTotal" v-if="totalAmount && totalAmount.length > 0">
        <div class="subTotal-label">
          {{ $t.customerBusinessStatistics.amount }}
        </div>
        <div class="subTotal-item" v-for="(item, index) in totalAmount" :key="index">
          <div class="item1">{{ item.key }}</div>
          <div class="item2">{{ item.value }}</div>
        </div>
      </div>
    </van-form>

    <div class="tool-bar">
      <van-button type="info" block v-if="menuState == 1" @click="gotoCustomerInfo(1)">{{
        $t.customerBusinessStatistics.button1
      }}</van-button>
      <van-button type="info" block v-if="menuState == 2" @click="gotoCustomerInfo(2)">{{
        $t.customerBusinessStatistics.button2
      }}</van-button>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { Form, Field, Button, Icon, Image } from "vant";

Vue.use(Form).use(Field).use(Button).use(Icon).use(Image);

export default {
  name: "customerBusinessStatisticsDetail",
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      form: {},
      menuState: 1,
      listAmount: [],
      totalAmount: [],
    };
  },
  created() {
    var data = JSON.parse(localStorage.getItem("customerBusinessStatisticsDetail"));
    this.form = data;
    this.menuState = this.form.menuState;
    this.firstLoad();
  },
  methods: {
    gotoCustomerInfo(type) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "customerBusinessStatisticsCustomerInfo",
        name: "customerBusinessStatisticsCustomerInfo",
        query: [
          {
            name: "CustomerId",
            value: this.form.CustomerId,
          },
          {
            name: "Type",
            value: type,
          },
        ],
      });
    },
    firstLoad() {
      var test = Object.entries(this.form.ReceivableAndPayableAmountDic);
      var array = test.map(([key, value]) => ({
        key,
        value,
      }));
      this.listAmount = array;

      var test = Object.entries(this.form.TotalAmountDic);
      var array = test.map(([key, value]) => ({
        key,
        value,
      }));
      this.totalAmount = array;
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    imagePreview(images) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.picturePreview, {
        pictureList: [images],
        startPosition: 0,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.customerBusinessStatisticsDetail {
  ::v-deep .number-label {
    line-height: 33px;
  }
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
  .subTotal {
    padding: 15px;
    font-size: 14px;
    color: #646566;
    .subTotal-label {
      margin-bottom: 15px;
    }
    .subTotal-item {
      display: inline-block;
      width: 33.33%;
      text-align: center;
      .item1 {
        padding: 10px;
        background: #1e90ff;
        color: #ffffff;
      }
      .item2 {
        padding: 10px;
        background: #e8f4ff;
      }
    }
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .van-button {
      border-radius: 0px;
    }
  }
}
</style>
